/**
 * Supply composition constants per `02-rules-spec.md` §2 and §6.5.
 *
 * Tile counts per player count include the starter cluster tiles separately
 * (3 tiles per player × player count).
 */

import type { PlayerCount } from "../types/game-config";

export interface BagComposition {
  readonly habitatTileCount: number;
  readonly keystoneTileCount: number;
  readonly wildlifeTokenCount: number;
  readonly natureTokenCount: number;
  readonly wildlifeScoringCardCount: number;
  readonly landmarkTokenCount: number;
  readonly landmarkScoringCardCount: number;
}

export const BASE_BAG: BagComposition = {
  habitatTileCount: 85,
  keystoneTileCount: 25,
  wildlifeTokenCount: 100,
  natureTokenCount: 25,
  wildlifeScoringCardCount: 21,
  landmarkTokenCount: 0,
  landmarkScoringCardCount: 0,
};

export const LANDMARKS_DELTA: BagComposition = {
  habitatTileCount: 45,
  keystoneTileCount: 0,
  wildlifeTokenCount: 35,
  natureTokenCount: 15,
  wildlifeScoringCardCount: 15,
  landmarkTokenCount: 30,
  landmarkScoringCardCount: 60,
};

export const STARTER_CLUSTER_COUNT = 5;

/**
 * Number of habitat tiles (excluding starter clusters) drawn into the supply
 * for the given player count. Returns `null` for unsupported combinations.
 */
export const tilesPerPlayerCount = (
  playerCount: PlayerCount,
  landmarks: boolean,
): number | null => {
  if (landmarks) {
    switch (playerCount) {
      case 1:
        return 44;
      case 2:
        return 45;
      case 3:
        return 66;
      case 4:
        return 87;
      case 5:
        return 108;
      case 6:
        return 129;
      default:
        return null;
    }
  }
  switch (playerCount) {
    case 2:
      return 43;
    case 3:
      return 63;
    case 4:
      return 83;
    default:
      return null;
  }
};

export const MARKET_SLOT_COUNT = 4 as const;
export const MAX_LANDMARKS_PER_PLAYER = 5 as const;
export const SOLO_HABITAT_BONUS_THRESHOLD = 7 as const;
export const SOLO_HABITAT_BONUS_POINTS = 2 as const;
export const LANDMARK_TRIGGER_CORRIDOR_SIZE = 5 as const;
